var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2962 11.6054C13.2962 10.6683 13.8413 9.37307 14.4889 8.70893C15.1531 8.04472 15.1531 6.97122 14.4889 6.30623C13.8247 5.64202 13.2962 4.34687 13.2962 3.40978C13.2962 2.47269 12.5295 1.70598 11.5924 1.70598C10.6553 1.70598 9.3601 1.1609 8.69596 0.513323C8.04838 -0.168196 6.95826 -0.168196 6.29326 0.496019C5.62906 1.16023 4.3339 1.68868 3.39681 1.68868C2.45972 1.68868 1.69301 2.45539 1.69301 3.39247C1.69301 4.32956 1.14793 5.62479 0.483044 6.28893C-0.16387 6.9538 -0.16387 8.04401 0.500348 8.69162C1.16456 9.35583 1.71032 10.651 1.71032 11.5881C1.71032 12.5252 2.47703 13.2919 3.41411 13.2919C4.3512 13.2919 5.64643 13.837 6.31057 14.5018C6.97478 15.1661 8.04827 15.1661 8.71326 14.5018C9.37747 13.8376 10.6726 13.2919 11.6097 13.2919C12.5468 13.2919 13.2962 12.5425 13.2962 11.6054Z",
    fill: "#28356A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53933 9.76286L5.3244 10.9043L5.73303 8.45114L3.96143 6.69606L6.41455 6.30405L7.53933 4.08911L8.66411 6.30405L11.1172 6.69606L9.34563 8.45114L9.75427 10.9043L7.53933 9.76286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumBusinessIcon);
export default __webpack_public_path__ + "static/media/premium_business_icon.0c5d2d09d64069f43d604a68c46a2d98.svg";
export { ForwardRef as ReactComponent };